import { render, staticRenderFns } from "./IconPrelevement.vue?vue&type=template&id=09b79046&"
import script from "./IconPrelevement.vue?vue&type=script&lang=js&"
export * from "./IconPrelevement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports